module.exports = __webpack_public_path__ + "img/group4.da7af0b0.png";